import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import './txnHistory.css';
import Pagination from "react-js-pagination";
import { store } from "../../redux/store";
import { selectedRow } from "../../redux/misc-data/misc-data.action";

class BillPaymentHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			types: [
				{ value: "Electricity", label: "Electricity" },
				{ value: "Mobile", label: "Mobile" },
				{ value: "Gas", label: "Gas" },
				{ value: "Landline", label: "Landline" },
				{ value: "Broadband", label: "Broadband" },
				{ value: "Water", label: "Water" },
				{ value: "Insurance", label: "Insurance" }

			],
			statusValues: [
				{ value: "Success", label: "Success" },
				{ value: "Failed", label: "Failed" },
				{ value: "Pending", label: "Pending" }
			],
			optionalVal: [],
			activePage: 1,
			startIndex: 0,
			endIndex: 5,
			valList: []

		}
	}

	componentDidMount() {

		var val = "";
		var list = [];
		if (this.props.batchList.length > 0) {
			this.props.batchList.map(batch => {
				const map = new Map(Object.entries(batch.data.optional));
				var mapKeys = [...map.keys()];
				var val = "";
				mapKeys.map(key => {
					val = val + key + " : " + map.get(key) + ";"
				})

				list.push(batch.data.orderId + ">>>" + val);

			})

		}

		this.setState({
			optionalVal: list
		})



	}
	componentWillUnmount() {
	}

	handlePageChangeDefault(pageNumber) {
		this.setState({
			activePage: pageNumber
		})

		console.log(pageNumber);
		var startIndex = (pageNumber - 1) * 5;
		var endIndex = pageNumber * 5;

		this.setState({
			startIndex: startIndex,
			endIndex: endIndex,
		})



	}

	selectRow = (event, data, id) => {
		event.preventDefault();
		store.dispatch(selectedRow(data.data));

		const map = new Map(Object.entries(data.data.optional));
		var valList = [];
		var mapKeys = [...map.keys()];
		if (mapKeys != undefined &&
			mapKeys.length > 0) {
			mapKeys.map(key => {
				var val = key + ":" + map.get(key);
				valList.push(val);

			})
		}

		this.setState({
			valList: valList
		})


	}

	printdiv = (event) => {
		event.preventDefault();
		var divContents = document.getElementById("body").innerHTML;
		var a = window.open('', '', 'height=1000, width=1000');
		a.document.write('<html>');
		a.document.write('<body>');
		a.document.write(divContents);
		a.document.write('</body></html>');
		a.document.close();
		a.print();
	}
	render() {

		return (
			<div>
				<div class="billhistory" id="txnlist">

					{this.props.batchList.length > 0 &&
						this.props.batchList
							.slice(this.state.startIndex, this.state.endIndex).
							map(batch => (
								<div class="txn-item" >
									<div class="txn-head" id={"txnhead" + batch.data.orderId}>
										<div class="collapsed" data-bs-toggle="collapse"
											data-bs-target={"#txn" + batch.data.orderId} aria-expanded="false"
											aria-controls={"txn" + batch.data.orderId}>
											<div class="txncard cdt" onClick={e => { this.selectRow(e, batch, e.target.billDate) }}>
												<div class="row">
													<div class="col-12 col-md-6">
														<div class="txntype">
															{/* <img src="images/dhbvn.png" alt="dhbvn" /> */}
															<h5>{batch.data.billerName}</h5>
															{this.state.optionalVal.length > 0 &&
																this.state.optionalVal.map(option => (
																	(option.split(">>>")[0] == batch.data.orderId)
																	&&
																	option.split(">>>")[1].split(";").map(opt => (
																		<h5>{opt.split(":")[0]} {opt.split(":")[1]}</h5>

																	))))
															}
															<p>CONSUMER CREATED ON: {moment(batch.data.createdOn).format('DD-MM-YYYY HH:mm:ss')}</p>

														</div>
													</div>

													<div class="col-7 col-md-4">
														<div class="txntype">
															<h5>ORDERID : {batch.data.orderId}</h5>
															<h5>BATCHID : {batch.data.batchId}</h5>
															<p>UPDATED ON: {moment(batch.data.updatedOn).format('DD-MM-YYYY HH:mm:ss')}</p>
														</div>
													</div>
													<div class="col-5 col-md-2">
														<div class="txntype text-end">
															<h5>Amount:</h5>


															<h4>{(batch.data.currentBillPayAmount != undefined &&
																batch.data.currentBillPayAmount != null &&
																batch.data.currentBillPayAmount != "")
																?
																batch.data.currentBillPayAmount.toLocaleString("en-US") :
																(batch.data.lastPaidBill != undefined &&
																	batch.data.lastPaidBill != null &&
																	batch.data.lastPaidBill != "" &&
																	batch.data.lastPaidBill.lastPaidBillAmount != undefined &&
																	batch.data.lastPaidBill.lastPaidBillAmount != null &&
																	batch.data.lastPaidBill.lastPaidBillAmount != "") ?
																	batch.data.lastPaidBill.lastPaidBillAmount.toLocaleString("en-US") :
																	"NA"}</h4>

															<p class="success">{batch.data.lastKnownStatus.split("_").join(" ")}</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div id={"txn" + batch.data.orderId} class="accordion-collapse collapse"
											aria-labelledby={"txnhead" + batch.data.orderId}
											data-bs-parent="#txnlist">
											<div class="subtxnshow">

												<div class="csmrdtl">
													<div class="row">
														<div class="col-12 col-md">
															<div class="txntsubdtl">
																<p>Consumer Name</p>
																<h5>{batch.data.consumerName}</h5>
															</div>
														</div>

														<div class="col-12 col-md">
															<div class="txntsubdtl">
																<p>Mobile no.</p>
																<h5>+91-{batch.data.mobileNo}</h5>
															</div>
														</div>

														<div class="col-12 col-md">
															<div class="txntsubdtl">
																<p>State</p>
																<h5>{batch.data.state}</h5>
															</div>
														</div>

														<div class="col-6 col-md">
															<div class="txntsubdtl">
																<p>Bill Date</p>
																<h5>{(batch.data.lastBillFetch != undefined &&
																	batch.data.lastBillFetch != null &&
																	batch.data.lastBillFetch.billDate != undefined &&
																	batch.data.lastBillFetch.billDate != null) ?
																	batch.data.lastBillFetch.billDate : 'NA'}</h5>
															</div>
														</div>

														<div class="col-6 col-md">
															<div class="txntsubdtl">
																<p>Bill Due Date</p>
																<h5>{(batch.data.lastBillFetch != undefined &&
																	batch.data.lastBillFetch != null &&
																	batch.data.lastBillFetch.dueDate != undefined &&
																	batch.data.lastBillFetch.dueDate != null) ?
																	batch.data.lastBillFetch.dueDate : 'NA'}</h5>
															</div>
														</div>
													</div>
												</div>
												{this.props.rowSelected != undefined &&
													<div class="txn-btn">
														<button type="button" class="print" data-bs-toggle="modal"
															data-bs-target="#print">Print</button>
													</div>
												}
											</div>
										</div>
									</div>
									{this.props.rowSelected != undefined &&
										this.props.rowSelected != '' &&
										this.props.rowSelected != null &&
										<div class="modal fade" id="print" data-bs-backdrop="static"
											data-bs-keyboard="false" tabindex="-1">
											<div class="modal-dialog">
												<div class="modal-content">
													<div class="modal-header modhead">
														<h5 class="modal-title">Print - {this.props.rowSelected.billerCategory} Bill Payment</h5>
														<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
													</div>
													<div class="modal-body" id="body">
														<div class="printtable">
															<div class="printlogo">
																<img src="images/finxpay.png" alt="FinXpay" class="float-start" />
																<img src="images/bbps-logo.png" alt="BBPS" class="float-end" />
															</div>
															<table class="table table-striped table-bordered">
																<thead>

																	<tr>
																		<td>Payment Status:</td>
																		<td class="text-success"><strong>{
																			this.props.rowSelected.lastKnownStatus
																				.split('_')
																				.join(' ')}</strong></td>
																	</tr>

																	{this.state.valList != undefined &&
																		this.state.valList.length > 0 &&
																		this.state.valList.map(val => (
																			<tr>
																				<td>{val.split(":")[0].split("_").join(" ")}:</td>
																				<td>{val.split(":")[1]}</td>
																			</tr>
																		))}

																	<tr>
																		<td>Bill Date:</td>
																		<td>{(this.props.rowSelected.lastBillFetch != undefined &&
																			this.props.rowSelected.lastBillFetch != null &&
																			this.props.rowSelected.lastBillFetch.billDate != undefined &&
																			this.props.rowSelected.lastBillFetch.billDate != null) ?
																			this.props.rowSelected.lastBillFetch.billDate : 'NA'}</td>
																	</tr>
																	<tr>
																		<td>Payment Date:</td>
																		<td>{moment(this.props.rowSelected.createdOn).format('DD-MM-YYYY HH:mm:ss')}</td>
																	</tr>
																	{(this.props.rowSelected.currentBillPayAmount != undefined &&
																		this.props.rowSelected.currentBillPayAmount != null &&
																		this.props.rowSelected.currentBillPayAmount) != "" ?
																		<tr>
																			<td>Amount:</td>
																			<td>₹ {this.props.rowSelected.currentBillPayAmount}</td>
																		</tr>:
																		(this.props.rowSelected.lastPaidBill != undefined &&
																		this.props.rowSelected.lastPaidBill != null &&
																		this.props.rowSelected.lastPaidBill != "" &&
																		this.props.rowSelected.lastPaidBill.lastPaidBillAmount != undefined &&
																		this.props.rowSelected.lastPaidBill.lastPaidBillAmount != null &&
																		this.props.rowSelected.lastPaidBill.lastPaidBillAmount != "") &&
																		<tr>
																			<td>Amount:</td>
																			<td>₹ {this.props.rowSelected.lastPaidBill.lastPaidBillAmount}</td>
																		</tr>
																	}
																	<tr>
																		<td>Payer Mobile No.:</td>
																		<td>{this.props.rowSelected.mobileNo}</td>
																	</tr>
																	<tr>
																		<td>State:</td>
																		<td>{this.props.rowSelected.state}</td>
																	</tr>
																	<tr>
																		<td>Provider:</td>
																		<td>{this.props.rowSelected.billerName}</td>
																	</tr>
																	<tr>
																		<td>Operator_id:</td>
																		<td>{(this.props.rowSelected.lastPaidBill != undefined &&
																			this.props.rowSelected.lastPaidBill != null &&
																			this.props.rowSelected.lastPaidBill != '' &&
																			this.props.rowSelected.lastPaidBill.optional != undefined &&
																			this.props.rowSelected.lastPaidBill.optional != null &&
																			this.props.rowSelected.lastPaidBill.optional != '' &&
																			this.props.rowSelected.lastPaidBill.optional.OPERATOR_ID != undefined &&
																			this.props.rowSelected.lastPaidBill.optional.OPERATOR_ID != null &&
																			this.props.rowSelected.lastPaidBill.optional.OPERATOR_ID != '') ?
																			this.props.rowSelected.lastPaidBill.optional.OPERATOR_ID : "NA"}</td>
																	</tr>
																	{this.props.rowSelected.orderId != undefined &&
																		this.props.rowSelected.orderId != null &&
																		this.props.rowSelected.orderId != "" &&
																		<tr>
																			<td>Reference No.:</td>
																			<td>{this.props.rowSelected.orderId}</td>
																		</tr>
																	}

																</thead>
															</table>

															<p>Thank you for your payment your payment will be updated at the biller's end with 2-3 days.</p>
														</div>
													</div>
													<div class="modal-footer mdftr">
														<button type="button" class="btn dbbtn" data-bs-dismiss="modal"
															onClick={this.printdiv}>Print</button>
													</div>
												</div>
											</div>
										</div>
									}

								</div>))

					}
				</div>

				<div class="pager">
					<p>Showing {this.state.startIndex + 1} to {this.state.endIndex >=
						this.props.batchList.length ?
						this.props.batchList.length :
						this.state.endIndex} of {this.props.batchList.length} entries</p>
					<Pagination
						activePage={this.state.activePage}
						itemsCountPerPage={5}
						totalItemsCount={
							this.props.batchList.length}
						pageRangeDisplayed={5}
						onChange={this.handlePageChangeDefault.bind(this)}
						className="pagination"
						linkClass="page-link"
						itemClass="page-item"
					/>
				</div>
			</div >

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, rowSelected } }
) => ({
	errorMessage, phone, rowSelected
});

export default connect(mapStateToProps, null)(BillPaymentHistory);
